import AccountButton from "../AccountButton";
import { normalizeText, truncateText } from "../utils";
import "./SalMineCardPrint.css";

function CardRow({ label, value }) {
  const rawText = normalizeText(value);
  const text = rawText ? truncateText(rawText) : "N/A";

  return (
    <div className="flex leading-[1.2] w-full items-start">
      <span className="uppercase text-gray-700 min-w-[58px] text-[8px] font-normal">
        {label}:
      </span>

      <span
        className={`
          ml-0.5 font-bold uppercase text-gray-900 break-words w-full text-[8px]
        `}
      >
        {text ?? "N/A"}
      </span>
    </div>
  );
}

export default function SalMineCardPrint({
  name = "Konner Hinz",
  dob = "10-25-1957",
  allergies = "PENICILLIN, PEANUTS",
  medications = "WARFARIN (COUMADIN)",
  conditions = "LIMITED HEARING IN RIGHT EAR\nDIABETES (See Reverse)",
  hospital = "MEMORIAL GENERAL",
  doctors = [{ name: "DR. JAMES SMITH", status: "current" }],
  religion = "CATHOLIC",
  updated = "03-15-2022",
  organDonor = true,
  bloodType = "B+",
  qrUrl = "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=example",
  emergencyContactName,
  emergencyContactPhone,
  emergencyRelation,
  ssn = "444-33-2222",
  hidePrintButton = false,
  downloadMode = false,
  ekg,
  onPrint,
}) {
  const formatSsn = (ssn) => {
    if (ssn && ssn.length >= 3) {
      const first3 = ssn.slice(0, 3);
      const formattedSsn = `${first3}-**-***`;
      return formattedSsn;
    }
    return "";
  };
  return (
    <div
      className={`sal-mine-print-card-modal ${
        downloadMode ? "download-mode" : ""
      }`}
    >
      <div
        id="sal-mine-print-card"
        className={`sal-mine-print-card bg-white rounded-lg border border-gray-400 grid ${
          organDonor
            ? "grid-cols-[3fr_15px_15px_1.4fr]"
            : "grid-cols-[3fr_15px_1.4fr]"
        } font-sans`}
        style={{
          width: "350px",
          height: "200px",
        }}
      >
        {/* LEFT SECTION */}
        <div className="pl-2 py-2 flex flex-col justify-between h-full">
          <h1 className="text-base font-extrabold whitespace-nowrap uppercase leading-tight">
            {truncateText(name, 20)}
          </h1>

          <div className="flex flex-col gap-1.5 text-[8px] leading-tight flex-1 justify-center">
            <CardRow label="Allergies" value={allergies} />
            <CardRow label="Medications" value={medications} />
            <CardRow label="Conditions" value={conditions} />
            <CardRow label="Hospital" value={hospital} />
            <CardRow label="Doctor" value={doctors} />
            {/* <CardRow label="Contact" value={contact} /> */}
            <CardRow label="Religion" value={religion} />

            {(emergencyContactName ||
              emergencyContactPhone ||
              emergencyRelation) && (
              <CardRow
                label="Emergency"
                value={[
                  emergencyContactName && `${emergencyContactName}`,
                  emergencyContactPhone && `${emergencyContactPhone}`,
                  emergencyRelation && `${emergencyRelation}`,
                ]}
              />
            )}
          </div>
        </div>

        {/* UPDATED BAR */}
        <div className="bg-gray-200 flex items-center justify-center">
          <span className="-rotate-90 whitespace-nowrap tracking-wide text-[8px] font-medium text-black">
            Updated: {updated}
          </span>
        </div>

        {/* ORGAN DONOR BAR */}
        {organDonor && (
          <div
            className={`bg-gray-600 flex items-center justify-center ${
              organDonor ? "" : "hidden"
            }`}
          >
            <span className="-rotate-90 whitespace-nowrap tracking-wide text-[8px] font-light text-white">
              DONOR
            </span>
          </div>
        )}

        {/* RIGHT SECTION */}
        <div className="bg-gray-100 py-2 flex flex-col items-center gap-2 rounded-tr-lg rounded-br-lg overflow-hidden w-full h-full">
          <div className="flex flex-col items-center gap-1 w-full">
            <div className="text-[8px] font-bold text-center leading-tight">
              <div>
                DOB: <span className="font-extrabold">{dob}</span>
              </div>
              <div>
                SSN: <span className="font-extrabold">{formatSsn(ssn)}</span>
              </div>
            </div>

            {/* QR */}
            <div className="bg-white p-1 w-full h-full">
              <img src={qrUrl} alt="QR" className="w-full h-20" />
            </div>

            {/* BLOOD TYPE */}
            <div className="bg-red-300 text-red-900 font-bold px-3 py-0.5 whitespace-nowrap text-[9px] w-full text-center">
              Blood Type&nbsp;
              <span className="font-extrabold text-[10px]">{bloodType}</span>
            </div>
          </div>

          {/* SIGNATURE / EKG */}
          {ekg && (
            <div>
              SSN: <span className="font-extrabold">{formatSsn(ssn)}</span>
            </div>
          )}
        </div>
      </div>

      {!hidePrintButton && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: 24,
          }}
        >
          <AccountButton
            className="w-full bg-gradient-to-r from-[#4962d8] to-[#2d348f] text-white font-semibold text-base py-2"
            onClick={onPrint || (() => window.print())}
          >
            Print
          </AccountButton>
        </div>
      )}
    </div>
  );
}
